export const lazyOptions = {
    triggerOnce: true,
    rootMargin: "300px 0px",
};

type Size = number | string | undefined;

export const placeholderSrc = ([width, height]: [Size, Size]) => `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`;
